import Vue from "vue";

const state = {
  data: [],

  initialised: false,
};

/* eslint-disable no-shadow, no-param-reassign, arrow-body-style */
const actions = {
  initialise: ({ state }) => {
    return Vue.http.get("/service-types?with=brand&limit=999").then((response) => {
      const { data } = response.body;

      state.data = data;

      state.initialised = true;
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
};
